import { MainButton } from 'global-styles/MainButton';
import { GoToIcon } from 'assets/icons';
import { useContactModal } from 'hooks/useContactModal';
import { useRouter } from 'next/router';
import styled from 'styled-components';

const ButtonsWithTryForFree = () => {
  const { locale } = useRouter();
  const { handleMoveToContactUsPage } = useContactModal();

  return (
    <>
      <ProductTemplateMainButton
        buttonType="default"
        text={locale === 'en' ? 'Try For Free' : '체험 해보기'}
        icon={<GoToIcon />}
        iconPosition="right"
        tag="a"
        href="https://www.kokoon.cloud"
        target="_blank"
      />
      <ProductTemplateMainButton
        onClick={handleMoveToContactUsPage}
        buttonType="default"
        text={locale === 'en' ? 'Contact us' : '제품 문의하기'}
      />
    </>
  );
};

const ButtonWithContact = () => {
  const { locale } = useRouter();
  const { handleMoveToContactUsPage } = useContactModal();
  return (
    <>
      <ProductTemplateMainButton
        onClick={handleMoveToContactUsPage}
        buttonType="default"
        text={locale === 'en' ? 'Contact us' : '제품 문의하기'}
      />
    </>
  );
};

export const ProductTemplateButtons = {
  sr: <ButtonsWithTryForFree />,
  pqo: <ButtonWithContact />,
  av1: <ButtonWithContact />,
  avif: <ButtonWithContact />,
  vmaf: <ButtonWithContact />,
};

const ProductTemplateMainButton = styled(MainButton)`
  width: 156px;
  height: 48px;
`;
